import { AutocompleteRenderInputParams, TextField } from '@mui/material'
import { AssigneesError } from '../types'

interface Props extends AutocompleteRenderInputParams {
  startAdornment?: React.ReactNode
  'data-testid': string | undefined
  placeholder: string
  onTabKeyDown: (newValue: string) => void
  error: AssigneesError | undefined
  helperText: string | undefined
  onBlur: (() => void) | undefined
  label?: string | React.ReactNode
  required?: boolean
  isAiPrefilled?: boolean
}
export const AssigneeAutocompleteTextField = ({
  startAdornment,
  'data-testid': dataTestId,
  placeholder,
  onTabKeyDown,
  error,
  helperText,
  onBlur,
  label,
  required,
  isAiPrefilled,
  ...props
}: Props) => {
  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Tab' && props.inputProps.value) {
      const target = event.target as HTMLInputElement

      onTabKeyDown(target.value)
    }
  }

  return (
    <TextField
      {...props}
      label={label}
      required={required}
      data-testid={dataTestId}
      placeholder={placeholder}
      error={Boolean(error)}
      helperText={helperText}
      onBlur={onBlur}
      data-is-ai-prefilled={isAiPrefilled}
      slotProps={{
        input: {
          sx: { minHeight: 50, maxHeight: 200 },
          onKeyDown: handleKeyDown,
          ...props.InputProps,
          startAdornment: startAdornment ?? props.InputProps?.startAdornment,
        },
      }}
    />
  )
}
